import type { PageUITrailEventProperties, PageUITrailResultSection } from './pageUI';
import trailFromPageUISection from './trailFromPageUISection';

/**
 * A page a click can open. Add one once hosts can open it; each host switches on this.
 */
export type PageUIRecordPage = 'trail-detail';

/**
 * What clicking a section does. The host app decides how to carry it out (which page, same tab or new),
 * since that depends on where the response is shown.
 */
export type PageUIClickAction = {
  action: 'open-record-page';
  page: PageUIRecordPage;
  slug: string;
};

export type PageUIClick = {
  clickAction: PageUIClickAction;
  eventProperties: PageUITrailEventProperties;
};

/**
 * Builds a trail result's click action on the client, until the server sends `clickAction`. The analytics are the server's.
 */
const clickFromSection = (section: PageUITrailResultSection): PageUIClick => ({
  clickAction: { action: 'open-record-page', page: 'trail-detail', slug: trailFromPageUISection(section).slug },
  eventProperties: section.eventProperties
});

export default clickFromSection;
